import { atom, type Atom } from "@tldraw/state";
import type { Editor } from "./canvas";
import type { Point } from "../shared/schema";
import type { LineAxis } from "./line-alignment";

type LineGuide = {
  start: Point;
  end: Point;
  axis: LineAxis;
  locked: boolean;
};

// Shared by creation and endpoint editing, local to this editor and never synced.
const guides = new WeakMap<Editor, Atom<LineGuide | null>>();
export function getLineGuide(editor: Editor) {
  let guide = guides.get(editor);
  if (!guide) {
    guide = atom<LineGuide | null>("line alignment guide", null);
    guides.set(editor, guide);
  }
  return guide;
}
